import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { URL_PATHS } from "../../src/routes";
import { NewPayment, paymentActions } from "../../src/store/payment";
import { PaymentMethod } from "../generated/lib-domain/iap";
import PaymentInfoPage from "../pages/PaymentInfo";
import { AppState } from "../store";
import dayjs from "dayjs";
import { DATE_FORMAT } from "../shared/date-format";
import { PaymentPlanEnum } from "../generated/UserAPIAgent";

const PaymentInfoContainer = (): JSX.Element => {
    const { paymentStatus, myUser } = useSelector((state: AppState) => ({
        paymentStatus: state.payment.status,
        myUser: state.myData.user
    }));
    const dispatch = useDispatch();
    const history = useHistory();
    const info = {
        cardNumberSuffix: paymentStatus.creditCardInfo.cardNumberSuffix,
        nextPaymentDate: paymentStatus.nextPaymentDate as string,
        paidFinishDate: paymentStatus.paidFinishDate as string,
        primaryPaymentMethod:
            paymentStatus.primaryPaymentMethod as PaymentMethod,
        paymentType: paymentStatus.paymentType,
        // NOTE cardPaymentTransitionApplicationDate カード移行を申請した日
        cardPaymentTransitionApplicationDate:
            paymentStatus.cardPaymentTransitionApplicationDate,
        currentPaymentPlan: paymentStatus.currentPaymentPlan,
        cardPaymentPlans: paymentStatus.cardPaymentPlans,
        iapPaymentPlans: paymentStatus.iosIapPaymentPlans
    };
    const onNavigateToPaymentMake = (
        newPaymentPlanId: PaymentPlanEnum
    ): boolean => {
        const newCardPaymentPlan = paymentStatus.cardPaymentPlans.find(
            (plan) => plan.paymentPlanId === newPaymentPlanId
        );
        const newPayment: NewPayment = {
            paymentPlanId: newPaymentPlanId,
            campaignId: newCardPaymentPlan.campaigns[0]?.campaignId || null,
            amount: newCardPaymentPlan.amount,
            firstAmount: newCardPaymentPlan.campaigns[0]?.firstAmount || null
        };
        dispatch(paymentActions.selectedPaymentSet(newPayment));
        dispatch(paymentActions.paymentInProgressSet(true));
        history.push(URL_PATHS.paymentMake3DS());
        // a tag で遷移するとき、href を無効にするためreturn false する
        return false;
    };
    const onChangeCreditCardInfo = (): boolean => {
        dispatch(paymentActions.isChangeCardInfoInProgressSet(true));
        dispatch(paymentActions.paymentInProgressSet(true));
        history.push(URL_PATHS.paymentMake3DS());
        // a tag で遷移するとき、href を無効にするためreturn false する
        return false;
    };
    return (
        <PaymentInfoPage
            myUser={myUser}
            paymentMethod={info.primaryPaymentMethod}
            cardNo={info.cardNumberSuffix}
            nextUpdate={
                info.nextPaymentDate &&
                dayjs(info.nextPaymentDate).format(DATE_FORMAT.YYYY年M月D日)
            }
            paidFinishDate={
                info.paidFinishDate &&
                dayjs(info.paidFinishDate).format(DATE_FORMAT.YYYY年M月D日)
            }
            isChangedPaymentMethod={
                info.cardPaymentTransitionApplicationDate != null
            }
            paymentType={info.paymentType}
            onNavigateToPaymentMake={onNavigateToPaymentMake}
            currentPaymentPlan={info.currentPaymentPlan}
            cardPaymentPlans={info.cardPaymentPlans}
            onChangeCreditCardInfo={onChangeCreditCardInfo}
        />
    );
};

export default PaymentInfoContainer;
